<template>
    <div>
      <base-tab :tabs="tabsData" @tab-click="tabSelected"></base-tab>
      <keep-alive>
        <component :is="orderComponent"
                   ref="listMethod"
                   @order-view="orderView"
                   :param="param">
        </component>
      </keep-alive>
    </div>
</template>

<script>
import OrderApple from './OrderApple'
import OrderLoading from './OrderLoading'
import OrderFinish from './OrderFinish'
import OrderAll from './OrderAll'

export default {
  name: 'OrderList',
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  components: {
    'order-apple': OrderApple,
    'order-loading': OrderLoading,
    'order-finish': OrderFinish,
    'order-all': OrderAll
  },
  data () {
    return {
      orderId: '',
      orderComponent: 'order-apple',
      tabsData: [
        {id: 'apple', name: '客户预约', badge: 0, finish: false},
        {id: 'loading', name: '服务中', badge: 0, finish: false},
        {id: 'finish', name: '已完成', badge: 0, finish: false},
        {id: 'all', name: '所有', badge: 0, finish: false}
      ]
    }
  },
  methods: {
    changeEvent (value) {
      this.$refs['listMethod'].changeEvent(value)
    },
    orderView (view, param) {
      this.$emit('order-view', view, param)
    },
    tabSelected (tab) {
      let menu = 'order-' + this.tabsData[tab.index].id
      let finish = this.tabsData[tab.index].finish
      this.$nextTick(() => {
        if (!finish) this.tabsData[tab.index].finish = true
        else this.$refs['listMethod'].changeEvent('flush')
      })
      this.orderComponent = menu
    }
  }

}
</script>

<style scoped>

</style>
